export const SHOPPING_CATEGORIES = [
  'Meat / Seafood',
  'Dairy',
  'Produce',
  'Grocery',
  'Other',
  'Staples',
] as const

export type ShoppingCategory = (typeof SHOPPING_CATEGORIES)[number]

// Unit abbreviation (e.g. "cup", "tbsp") from the units_of_measurement table.
export type ShoppingUnit = string

export type ShoppingUnitOption = {
  id: number
  label: string
  // Lowercased names a user might type for this unit ("cup", "c").
  aliases?: string[]
}

// One recipe (or typed amount) that adds up to a combined item.
export type ShoppingItemSource = {
  // What this amount was called when it was added ("red onion").
  name?: string
  recipeId?: string
  recipeName?: string
  amount: string
}

export type ShoppingItem = {
  id: string
  name: string
  quantity: string
  unit: ShoppingUnit
  category: ShoppingCategory
  purchased: boolean
  // Every recipe that contributed to this item (more than one once combining lands).
  recipeIds: string[]
  recipeName?: string
  // Amounts that add up to this item; more than one means it was combined.
  sources: ShoppingItemSource[]
  // True when the person typed the quantity themselves (recipe changes won't overwrite it).
  quantityEdited: boolean
  // Other items on the list with a near-match name; suggestions only.
  similarIds: string[]
}

// An ingredient of a recipe that is already on another of the person's lists.
export type ShoppingOverlap = {
  recipeIngredientId: number
  ingredientName: string
  itemId: number
  itemName: string
  itemQuantity: string
  listId: string
  listName: string
  exact: boolean
}

export type ShoppingListRecipe = {
  id: string
  name: string
  slug?: string
}

// Someone else on a shared list (the owner is described by ShoppingList.ownerName).
export type ShoppingMember = {
  id: string
  userId?: number
  name: string
}

export type ShoppingList = {
  id: string
  name: string
  ownerName: string
  isOwner: boolean
  members: ShoppingMember[]
  createdAt: string
  updatedAt: string
  items: ShoppingItem[]
  recipes: ShoppingListRecipe[]
}

export type RecipePayload = {
  id: string
  name: string
  slug?: string
  ingredients: Array<{
    name: string
    quantity?: string
    unit?: string
  }>
}
